import { Button } from "../common/button"

export const HeroSection = () => {
    const scrollToSection = () => {
        const section = document.getElementById('header-section');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="relative w-full py-24 sm:py-24">
            <div className="mx-auto max-w-7xl px-6">
                <div className="mx-auto max-w-4xl lg:mx-0">
                    <h2 className="text-4xl font-semibold tracking-[0%] text-white md:text-6xl font-oxanium" style={{ lineHeight: 'normal' }}>Internal Mobility, AI-Powered Referrals, and Recruiter Collaboration — All in One Platform.</h2>
                    <p className="my-8 text-white text-base sm:text-2xl font-lato font-light">
                        AIAURA Core helps recruitment agencies and talent teams hire faster, <br /> cheaper, and smarter with tools built for today’s market.
                    </p>
                    <Button classes={`text-base sm:text-xl font-semibold py-3 sm:py-5 px-8 sm:px-16 rounded-full`} text={`Get a demo`} />
                </div>
                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-max bg-gradient-to-r from-white to-[#52BBD4] text-transparent bg-clip-text font-lato sm:text-xl">AI-Driven Talent, Real-World Results</div>
                <button onClick={scrollToSection} className="fixed bottom-32 sm:bottom-40 md:bottom-1/3 right-12 h-12 sm:h-[72px] w-12 sm:w-[72px] z-30">
                    <img src="/arrow.png" alt="" className="h-full w-full" />
                </button>
            </div>
            <img src="/circle1.png" alt="" className="h-[700px] absolute -left-[22%]"/>
        </div>
    )
}
